import React from 'react';
import dayjs from 'dayjs';

// --- Hook
import { useAtom } from 'jotai';
import { waterMonitoring } from '../../store/atoms/waterMonitoring.atom';
import { Link } from 'react-router-dom';
import { UrlCollection } from '../../common/url-collection';

// --- Store
import { useAtomValue } from 'jotai';
import { mapInstanceAtom, mapControlsAtom } from '../../store/atoms/map';

import { listDeviceStatus } from '../../utils/helper';
interface OverlayPopupProps {
    coordinate: [number, number];
    station: any[];
    onClose: () => void;
}

const OverlayPopup: React.FC<OverlayPopupProps> = ({ coordinate, station, onClose }) => {
    const [waterMonitoringData] = useAtom(waterMonitoring);
    const mapInstance = useAtomValue(mapInstanceAtom);
    const mapControls = useAtomValue(mapControlsAtom);

    const handleClick = (station: any) => {
        mapInstance && mapControls.showStationOverlayAtCoordinate([station.longitude, station.latitude], station);
        mapInstance && mapControls.setCenter([station.longitude, station.latitude], 12);
    }

    const waterMonitoring_ = waterMonitoringData?.find((item: any) => item.stationId === station[0]?.id);

    return (
        <div className="overlay_popup">
            <div className="flex justify-end">
                <button onClick={onClose} className="text-gray-500 hover:text-black">×</button>
            </div>
            {station.length === 1 ? (
                <>
                    <div className="flex justify-between items-center gap-8 mb-1">
                        <span className="font-semibold color_green">{station[0]?.name}</span>
                        <Link to={`${UrlCollection.Station}/${station[0]?.id}`} target="_blank" className="text-blue-500 hover:text-blue-700">Chi tiết</Link>
                    </div>
                    <div className="text-sm">
                        <div><span className="font-semibold">Địa chỉ:</span> <span>{station[0]?.address}</span></div>
                        <div className='flex gap-2'>
                            <div><span className="font-semibold">Kinh độ:</span> <span>{station[0]?.longitude}</span></div>
                            <span>-</span>
                            <div><span className="font-semibold">Vĩ độ:</span> <span>{station[0]?.latitude}</span></div>
                        </div>
                    </div>
                    {waterMonitoringData && waterMonitoringData?.length > 0 && (
                        <>
                            <div className="text-sm">
                                <div><span className="font-semibold">Thời gian:</span><span> {dayjs(waterMonitoring_?.waterMonitoringTime).format('DD/MM/YYYY HH:mm:ss')}</span></div>
                            </div>
                            <div className="max-h-[200px] overflow-y-auto mt-2">
                                <table className="w-full text-sm">
                                    <thead className="sticky top-[-1px] z-10 border bg-white text-center">
                                        <tr className="">
                                            <th className="text-center py-1">STT</th>
                                            <th className="text-center py-1">Thông số</th>
                                            <th className="text-center py-1">Giá trị</th>
                                            <th className="text-center py-1">Đơn vị</th>
                                            <th className="text-center py-1">Trạng thái</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {waterMonitoring_?.data?.map((item: any, index: number) => {
                                            const status = listDeviceStatus.find((status: any) => status.value === item.deviceStatus);
                                            const color = status?.color || "gray";
                                            return (
                                                <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : ''}>
                                                    <td className="text-center py-1 ">{index + 1}</td>
                                                    <td className="text-center py-1">{item.parameterName}</td>
                                                    <td className="text-center py-1">{item.value}</td>
                                                    <td className="text-center py-1">{item.parameterUnit}</td>
                                                    <td className="flex justify-center items-center py-1">
                                                        <div className={`w-4 h-4 rounded-full bg-${color}`}></div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </>
            ) : station.length > 1 ? (
                <>
                    {station.map((item: any, index: number) => (
                        <div key={index} className="pb-2 mb-2 border-b last:border-b-0 last:mb-0">
                            <div className="flex justify-between items-center gap-8 mb-1">
                                <span className="font-semibold color_green">{item.name}</span>
                                <span onClick={() => handleClick(item)} className="text-blue-500 cursor-pointer hover:text-blue-700">Xem</span>
                            </div>
                            <div className="text-sm">
                                <div><span className="font-semibold">Địa chỉ:</span> {item.address}</div>
                                <div className='flex gap-2'>
                                    <div><span className="font-semibold">Kinh độ:</span> {item.longitude}</div>
                                    <span>-</span>
                                    <div><span className="font-semibold">Vĩ độ:</span> {item.latitude}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </>
            ) : (
                <div className="text-center">Không có dữ liệu</div>
            )}
        </div>
    );
};

export default OverlayPopup;
